// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"300":"peisong","631":"shoukuan","792":"main","930":"setup","966":"login"}[chunkId] + "." + {"300":"acdd0909","631":"b2aec6de","792":"43e1acfc","930":"d61afeb8","966":"a9513f06"}[chunkId] + ".css";
};